class SvgReplacer extends BaseClass {

    constructor(image) {
        super(image);
        this.image = image;
        this.imageSrc = this.image.src;
        this.newImageSrc = '';
        this.getSourceString();
    }

    getSourceString() {
        window.fetch(this.imageSrc)
            .then(response => response.text())
            .then(body => {
                this.newImageSrc = body;
                this.doReplace();
            });
    }

    doReplace() {
        this.image.insertAdjacentHTML("afterend", this.newImageSrc);
        this.image.parentNode.removeChild(this.image);
        this.raiseEvent("replaced");
    }

}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-svg-src]').forEach(el => {
        new SvgReplacer(el);
    });

});